<template>
	<header class="zov-layout-header"><slot>Header</slot></header>
</template>
<script>
const prefix = 'zov-layout-header'
export default {
	name: prefix
}
</script>
